import {
  useEffect, useState,
} from 'react';
import { useSelector } from 'react-redux';

function useDeviceData() {

  const [infoDevice, setInfoDevice] = useState({});
  const generalInfo = useSelector(({ telemetry: tel }) => tel.generalDeviceInfo);

  useEffect(() => {

    setInfoDevice(generalInfo);

  }, [generalInfo]);

  return {
    infoDevice,
  };

}

export default useDeviceData;
